import styled from 'styled-components';
import Button from '../button/button';

export const StyledLoadingButton = styled(Button)<{ $isLoading?: boolean }>`
  ${({ $isLoading }) => ($isLoading ? 'cursor: wait' : '')};
`;
